module.exports = __webpack_public_path__ + "img/TNT_Vacature_0-1.d6b50ffd.jpg";